import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { Video, WithRelatedVideos } from '../interfaces/Video';

export async function getVideoById(
    id: string,
    params?: { sortBy?: string; orderBy?: 'ASC' | 'DESC' }
): Promise<StandardResponse<WithRelatedVideos>> {
    const response: AxiosResponse<StandardResponse<WithRelatedVideos>> = await api.get(`/videos/${id}`, {
        params,
    });
    return response.data;
}

export async function getVideoBySubjectId(
    subjectId: string,
    params?: { sortBy?: string; orderBy?: 'ASC' | 'DESC' }
): Promise<StandardResponse<Video[]>> {
    const response: AxiosResponse<StandardResponse<Video[]>> = await api.get(`/videos?subjectId=${subjectId}`, {
        params,
    });
    return response.data;
}


export async function searchVideoBySubjectId(
    subjectId: string,
    params?: { sortBy?: string; orderBy?: 'ASC' | 'DESC', keyword: string }
): Promise<StandardResponse<Video[]>> {
    const response: AxiosResponse<StandardResponse<Video[]>> = await api.get(`/search/videos?subjectId=${subjectId}`, {
        params,
    });
    return response.data;
}

export async function markAsWatched(videoId: string, action: string): Promise<StandardResponse<string[]>> {
    const response: AxiosResponse<StandardResponse<string[]>> = await api.post('/users/videos/actions', {
        videoId,
        action
    });
    return response.data;
}

export async function searchVideos(params?: { keyword?: string; }
): Promise<StandardResponse<Video[]>> {
    const response: AxiosResponse<StandardResponse<Video[]>> = await api.get('/search/videos', {
        params
    });
    return response.data;
}

export async function markVideoAsRecentlyWatched(
    id: string,
    params?: { sortBy?: string; orderBy?: 'ASC' | 'DESC' }
): Promise<StandardResponse<WithRelatedVideos>> {
    const response: AxiosResponse<StandardResponse<WithRelatedVideos>> = await api.get(`/videos/${id}/view`, {
        params,
    });
    return response.data;
}